import { Box } from "@mui/material";
import React from "react";
import {
  allowedToDeleteEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { ttsEventColumns as columns } from "../../Helper";
import { isOpenPopup } from "src/utils/isOpenPopup";

const GetTTSEventColumns = ({ handleDelete, handleOpenPopup, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button className="btn btn-danger" onClick={() => handleDelete(item)}>
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetTTSEventColumns;
